module.exports = "https://wrf-static.prod-my.games/promo/long-lp/img/email.9b8b481c.svg";